import { useTranslation } from "react-i18next";
import { StaticFileFrame } from "../../staticfiles/components/StaticFileFrame";
import { StaticFileModule } from "../../staticfiles/enums";

export const InvestCombinationsContainer = () => {
  const { t } = useTranslation();

  return (
    <StaticFileFrame
      module={StaticFileModule.INVEST_COMBINATIONS}
      title={t("navigation.sideMenu.overviews.investCombinations")}
    />
  );
};
